import { type QueryHookOptions, useQuery } from '@apollo/client'

import { COMPANY_SETTING_BY_KEY } from '@/graphql/queries/CompanySetting'
import { useLoggedInUser } from '@/hooks'
import type { CompanySettingKey } from '@/gql/graphql'
import { batchClient } from '@/components/App/client'

interface CompanySettingResult {
  loading: boolean
  [key: string]: any
}

const useCompanySetting = (
  key: CompanySettingKey,
  defaultValue?: any,
  options?: QueryHookOptions,
): [any, CompanySettingResult] => {
  const { companyId } = useLoggedInUser()

  const {
    data = {},
    loading,
    ...rest
  } = useQuery(COMPANY_SETTING_BY_KEY, {
    variables: { companyId, key },
    skip: !companyId,
    client: batchClient,
    ...(options ?? {}),
  })

  return [
    data?.companySettingByCompanyIdAndKey?.value ||
      data?.companySettingByCompanyIdAndKey?.valueBoolean ||
      data?.companySettingByCompanyIdAndKey?.valueStorage ||
      defaultValue,
    { loading, ...rest },
  ]
}

export default useCompanySetting
